<div class="tab-content" id="pills-tabContent-MyFinance">
  <!--bookings tab-->
  <div id="pills-Bookings" role="tabpanel" aria-labelledby="pills-Bookings-tab">
    <div class="card-list mb-3">
      <div class="card status-card approve" *ngFor="let data of bookingData | paginate: {
        itemsPerPage: itemsPerPage,
        currentPage: currentPageBooking,
        totalItems: totalItemsBooking,
        id: 'booking'
      };let id = index">
        <div class="card-body">
          <div class="list-group list-group-horizontal">
            <div class="list-group-item">
              <p class="title">TOTAL BOOKING AMT</p>
              <div class="price">{{getTotalAmount(data) |currency:'INR':'symbol':'4.0-0'}}</div>
            </div>
            <div class="list-group-item ms-auto" style="cursor: pointer;">
            </div>
            <div class="list-group-item ms-auto">
              <p class="title d-none d-md-block">Request ID:<span class="cursor-pointer"
                  (dblclick)="copyMessage(data?.row_id)">{{ data?.row_id }}</span>
              </p>
              <div class="more text-end">
                <a (click)="moreDetails(data?.row_id, id, 'moreDetails');getVehicle(data);getDealerInfo(data?.vehicle_info,data?.division_id,flag,id);getLeadStatusInfo(data?.row_id,id);getreviewStatus(data?.vehicle_info,data?.division_id,data?.vc,id);">
                  <span class="d-none d-md-inline-block" *ngIf="flag == 'secure'">More Details</span>
                  <span class="d-none d-md-inline-block" *ngIf="flag == 'moreDetails'">{{
                    orderDetailsIndex != id ? 'More Details ' :
                    'Less Details '}}</span>
                  <span class="d-inline-block">
                    <img [src]='environment1 + "assets/images/new-images/rightArrowdarkBlue.svg"'
                      alt="rightArrowdarkBlue" loading="lazy">
                  </span>

                </a>
              </div>
            </div>
          </div>
          <div *ngIf="data?.points > 0 " class="offer-box">
            <div class="offer-content">
              <div class="coin-icon">
                <img [src]="environment1 + 'assets/images/Layer_2.webp'" alt="Layer-image">

              </div>
              <div class="offer-text" >
                <!-- <h3>{{data.scheme_message }}</h3> -->
                <h3>Unlock fantastic reward on your online finance and booking.</h3>
              <p *ngIf="data.scheme_master[0]?.scheme_bonus_type != 'Flat'">Score instant {{data?.valuepoints}}% of your booking amount as online reward points.</p>
              <span class="footnote">1 point = 1 INR</span>

              </div>
            </div>
            <!-- <div class="offer-action">
              <a href="#" class="view-offers">
                View offers
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </a>
            </div> -->
          </div>
          <div class="card-content">
            <div class="prod-item">
              <div class="prod-img">
                <a [routerLink]="redirect(data?.product)">
                  <img
                    src="{{data?.vehicle_info?.image[0]?.image_url != '' ? data?.vehicle_info?.image[0]?.image_url : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/placeholder.webp'}}"
                    class="img-fluid cursor" alt="product IMg" height="64" width="112" loading="lazy">
                </a>
              </div>
              <div class="prod-info">
                <a [routerLink]="redirect(data?.product)">
                  <div class="title cursor">
                    {{data?.product?.model}}

                    <span *ngIf="data?.vas_data?.length >= 0 && (data?.lead_channel == 'OSP_Configurator' || data?.lead_channel == 'Fleet Verse Configurator')">
                      <img [src]='environment1 + "assets/images/configurator.svg"' class="img-fluid" loading="lazy" />
                    </span>
                    <span  [ngClass]="isMobile ?'d-block':'ms-1'" *ngIf="data?.solr_data && data.solr_data?.length > 0 && data.solr_data[0]?.VC_NUM_s">
                     ( VC - <span>{{data.solr_data[0].VC_NUM_s}})</span>
                    </span>
                  </div>
                </a>
                <div class="prod-price-quantity">
                  <div class="price" *ngIf="data?.vehicle_info?.price_range || data?.ex_showroom_price ">
                    {{data?.ex_showroom_price ?
                    (data?.ex_showroom_price |currency:'INR':'symbol':'4.0-0') :
                    data?.vehicle_info?.price_range ?
                    (data?.vehicle_info?.price_range
                    |currency:'INR':'symbol':'4.0-0') : '-'}}</div>
                  <div class="qty">QTY:<span>{{data?.quantity}}</span>
                  </div>
                  <div class="qty" *ngIf="data?.payment_status == 'UNBILLED'">BOOKING AMT:<span>{{
                      data?.vehicle_info?.down_payment ?
                      (data?.vehicle_info?.down_payment|currency:'INR':'symbol':'4.0-0') : "-" }}</span>
                  </div>
                  <div class="qty" *ngIf="data?.payment_status != 'UNBILLED'">BOOKING AMT:<span>{{
                      data?.payment_info?.amount ?
                      ((data?.payment_info?.amount / data?.quantity )|currency:'INR':'symbol':'4.0-0') :
                      "-" }}</span>
                  </div>
                  <div class="qty" *ngIf="data?.vas_data?.length > 0">VAS AMT:<span>{{
                      data?.vas_data[0].vas_payble_amount |currency:'INR':'symbol':'4.0-0' }}</span>
                  </div>
                  <div class="qty" *ngIf="data?.vas_data?.length > 0"><span><img
                        [src]='environment1 + "assets/images/vas.svg"' class="img-fluid" loading="lazy" /></span>
                  </div>
                </div>

              </div>
            </div>
            <div class="status ms-md-auto">
              <div
                *ngIf="data?.payment_status != 'aborted' && data?.payment_status != 'UNBILLED' && data?.payment_status != 'Payment Failed'">
                <span>{{ data?.payment_status | titlecase }}</span><img
                  [src]='environment1 + "assets/images/approve.png"' class="img-fluid" loading="lazy" />
              </div>
              <div
                *ngIf="data?.payment_status == 'aborted' || data?.payment_status == 'UNBILLED' || data?.payment_status == 'Payment Failed'">
                <span>{{ data?.payment_status | titlecase }}</span><img
                  [src]='environment1 + "assets/images/reject.png"' class="img-fluid" loading="lazy" />
              </div>
              <div class="quote">{{ data?.opty_status }}</div>
              <a [ngClass]="{'d-inline-flex': isMobile}" *ngIf="data.opty_id && getCreatedDate(data?.created_date) && checkPrice(data?.ex_showroom_price,data?.vehicle_info?.price_range)" (click)="getQUotationdata(data)" class="text-secondary" style="cursor: pointer;">
                <span>Download Quotation</span>
                <span class="ms-1">
                  <img [src]='environment1 + "assets/images/download.svg"' style="height: 15px;" loading="lazy" alt="">

                </span>
              </a>
            </div>
          </div>

          <div class="list-group list-group-horizontal card-foot rating-prod" style="border-radius: 0;"
            *ngIf="selectedSubTab != 'Builds' && data?.opty_status === 'C3 (Vehicle Delivered)'">
            <div class="list-group-item d-flex" style="align-items: baseline;"
              *ngIf="Review_status?.product_review_status == 'UNDER REVIEW' || Review_status?.product_review_status == 'PENDING'">
              <div class="title" style="color: #666C84;">YOUR RATING FOR PRODUCT |
              </div>
              <div class="rating" style="margin-left: 10px;">
                UNDER REVIEW
              </div>

            </div>
            <div class="list-group-item d-flex" style="align-items: baseline;"
              *ngIf="!Review_status?.product_review_status || Review_status?.product_review_status == 'DISAPPROVED'">
              <div class="title" style="cursor: pointer;" (click)="getVehicleDetail(data)">Rate the
                product
              </div>
              <div class="rating" style="margin-left: 20px;cursor: pointer;">
                <ngx-stars (click)="getVehicleDetail(data)" [readonly]="true" [customStarIcons]="heartUrls"
                  [color]="'#FDC602'" [initialStars]="0" [size]="5"></ngx-stars>
              </div>
            </div>
            <div class="list-group-item d-flex" style="align-items: baseline;"
              *ngIf="Review_status?.product_review_status == 'APPROVED'">
              <div class="title" style="color: #666C84;">YOUR RATING FOR PRODUCT |
              </div>
              <span style="margin-left: 10px;">
                {{ Review_status.product_rating_average }}
              </span>
              <!-- <div class="rating" style="margin-left: 10px;">
                <ngx-stars [readonly]="true" [customStarIcons]="heartUrls" [color]="'#307FE2'"
                  [initialStars]="1" [maxStars]="1" [size]="5"></ngx-stars>
              </div> -->
              <div class="col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                <div class="rating" style="margin-left: 10px;">
                  <ng-container>
                    <ngx-stars [readonly]="true" [customStarIcons]="heartUrls" [color]="'#FDC602'"
                      [initialStars]="Review_status.product_rating_average" [size]="5"></ngx-stars>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="list-group-item ms-auto">
              <div class="text-end d-flex" style="align-items: baseline;"
                *ngIf="Review_status?.dealer_review_status == 'UNDER REVIEW'  || Review_status?.dealer_review_status == 'PENDING'">
                <div class="title" style="color: #666C84;">YOUR RATING FOR DEALER |
                </div>
                <div class="rating" style="margin-left: 10px;">
                  UNDER REVIEW
                </div>
              </div>
              <div class="more text-end" (click)="getDealerData(data, 'dealer')"
                *ngIf="!Review_status?.dealer_review_status || Review_status?.dealer_review_status == 'DISAPPROVED'">
                Rate the
                dealer
                <img [src]='environment1 + "assets/images/new-images/r_arrow_navy.svg"' alt="right Arrowdark"
                  loading="lazy">
              </div>
              <div class="text-end d-flex" style="align-items: baseline;"
                *ngIf="Review_status?.dealer_review_status == 'APPROVED'">
                <div class="title" style="color: #666C84;">YOUR RATING FOR DEALER |
                </div>
                <span style="margin-left: 10px;">
                  {{ Review_status.dealer_rating_average }}
                </span>
                <!-- <div class="rating" style="margin-left: 10px;">
                  <ngx-stars [readonly]="true" [customStarIcons]="heartUrls" [color]="'#307FE2'"
                    [initialStars]="1" [maxStars]="1" [size]="5"></ngx-stars>
                </div> -->
                <div class="col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                  <div class="rating cursor-pointer " style="margin-left: 10px;">
                    <ng-container>
                      <ngx-stars [readonly]="true" [customStarIcons]="heartUrls" [color]="'#FDC602'" (click)="getDealerData(data, 'dealer')"
                        [initialStars]="Review_status.dealer_rating_average" [size]="5"></ngx-stars>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div *ngIf="data.isRating" style="font-weight: 700; font-size: 14px; line-height: 20px; color: #666C84;">
                Review Submitted
                <img [src]='environment1 + "assets/images/new-images/tick.svg"' alt="tick" loading="lazy">
              </div>
            </div>
          </div>

          <div class="list-group list-group-horizontal align-items-center card-foot" style="border-radius: 0;">

            <div class="list-group-item ms-auto" [ngClass]="{'display-none': data.lead_type!='FINANCE'}">
              <button class="btn btn-primary ps-4 pe-4 ms-auto book-now-btn btn-grad-primary btn-brand"
                style="margin-right: 10px;" data-toggle="tooltip" data-placement="top" title="Click here for Track"
                (click)="generateChallengeToken(data);" *ngIf="data.lead_type=='FINANCE'">Track
              </button>
              <button class="btn btn-primary ps-4 pe-4 ms-auto book-now-btn btn-grad-primary btn-brand"
                style="margin-right: 10px;" hidden data-bs-toggle="modal" data-toggle="tooltip" data-placement="top"
                title="Click here for Track" data-bs-target="#fetchOn_price" id="fetch_btn"
                *ngIf="data.lead_type=='FINANCE'">Track
              </button>

              <button class="btn btn-primary ps-4 pe-4 ms-auto book-now-btn btn-grad-primary btn-brand "
                (click)="makeFNIPayment(data)" data-toggle="tooltip" data-placement="top" title="Click here for Booking"
                *ngIf="( data?.payment_status == 'PENDING') && (data?.opty_status == 'C1 (Quote Tendered)' || data?.opty_status == 'C1A (Papers submitted)') &&(data.lead_type=='FINANCE')">Book
                Now</button>
            </div>
            <div class="list-group-item container"
              *ngIf="data?.lead_type=='BOOKING' || (data?.lead_type=='FINANCE' && data?.payment_status !='PENDING') ">
              <div class="row">
                <div class="col-md-6">
                  <!-- <div *ngIf="data?.vas_data?.length > 0 && data?.payment_info?.type_of_pay_gate !=='CCAVENUE'">
                    <h6 class="vas-text">VAS Booking Amount: </h6>
                    <div class="float-left">
                      <div class="d-flex">
                        <h5 class="vas-price"> {{data?.vas_data[0]?.vas_payble_amount |
                          currency:'INR':'symbol':'4.0-0'}}</h5>
                        <button  data-bs-target="#Proceed-Payment" class="vas-pay-now"
                          (click)="makeVASPayment(data)" *ngIf="data?.payment_status == 'Payment Confirmed' && data?.vas_data[0]?.payment_status !== 'Payment Confirmed'
                     && data?.payment_info?.type_of_pay_gate !== 'CCAVENUE'
                     " data-toggle="tooltip" data-placement="top" title="Click here for Payment">Pay
                          Now </button>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="col-md-6 align-self-end">
                  <div style="display: inline-block;">
                  <button *ngIf="((data?.opty_status=='C1 (Quote Tendered)' && data?.payment_status!=='Payment Confirmed') || (data?.opty_status=='C1A (Papers submitted)' && data?.payment_status!=='Payment Confirmed') || (data?.opty_status =='C2 (Adv. Received)'&& data?.payment_status=='Payment Confirmed')) && data?.lead_type !== 'FINANCE' && data?.opty_id && data?.opty_status && isAssignLogin(solrDataArray,data?.opty_id)" class="btn btn-primary ps-4 pe-4 ms-auto book-now-btn btn-grad-primary btn-brand fniJourney"
                  (click)="gotoFniform(data?.product,data?.opty_id,data?.opty_status,data)">Start F&I Journey
                </button>
              </div>
                  <div class="float-right">
                    <h6 class="vas-text">Booking Amount:</h6>
                    <div class="d-flex">
                      <div class="price"
                        *ngIf="data?.payment_status == 'UNBILLED' && data?.payment_info?.type_of_pay_gate !=='CCAVENUE'">
                        <!-- {{ data?.vehicle_info?.down_payment ?
                        ((data?.vehicle_info?.down_payment *data?.quantity)
                        |currency:'INR':'symbol':'4.0-0') : "-" }} -->
                        {{getTotalAmount(data) |currency:'INR':'symbol':'4.0-0'}}
                      </div>
                      <div class="price"
                        *ngIf="data?.payment_status != 'UNBILLED' && data?.payment_info?.type_of_pay_gate !=='CCAVENUE'">
                        <!-- {{data?.payment_info?.amount ?
                        ((data?.payment_info?.amount )|currency:'INR':'symbol':'4.0-0') : "-"}} -->
                        {{getTotalAmount(data) |currency:'INR':'symbol':'4.0-0'}}
                      </div>

                      <div class="price"
                        *ngIf="data?.payment_status == 'UNBILLED' && data?.payment_info?.type_of_pay_gate =='CCAVENUE'">
                        {{getTotalAmount(data) |currency:'INR':'symbol':'4.0-0'}}
                      </div>
                      <div class="price"
                        *ngIf="data?.payment_status != 'UNBILLED' && data?.payment_info?.type_of_pay_gate =='CCAVENUE'">
                        {{getTotalAmount(data) |currency:'INR':'symbol':'4.0-0'}}
                      </div>
                      <button  data-bs-target="#Proceed-Payment" *ngIf="((data?.payment_status != 'Payment Confirmed') &&
                    (data?.opty_status == 'C1 (Quote Tendered)' ||
                    data?.opty_status == 'C1A (Papers submitted)' ||
                    data?.opty_status == 'PENDING')) " (click)="Payment(data,data?.division_id)" class="vas-pay-now">Pay
                        Now</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!--order details web view-->
        <div class="ps-3 pe-3">

          <h1 class="page-sub-title cv-text-dark mb-4 mt-4" style="font-size: 24px;"
            *ngIf="!showBookingList && orderDetailsIndex == id">
            <div
              *ngFor="let statusOfTimeLine of (ProgressBarData && showTimeLine && showEdd ? ProgressBarData  : numSequence((data?.lead_channel =='OSP_Configurator'|| data?.lead_channel =='Fleet Verse Configurator') ? data?.quantity :1))" [ngStyle]="{'overflow-x': (data?.lead_channel === 'OSP_Configurator' || data?.lead_channel =='Fleet Verse Configurator') && !isMobile ? '' : ''}">
              <div class="rounded-0 border-top progress-box">
                <ul class="progressbar"  [ngStyle]="{'white-space': (data?.lead_channel === 'OSP_Configurator'|| data?.lead_channel =='Fleet Verse Configurator') ? 'break-spaces' : ''}" >
                  <li [ngClass]="getLeadCss(Lead_Status_info,'Request Accepted')">
                    <span class="step-desc">Request Accepted</span>
                    <span class="step-date"> {{getLeadStatus(Lead_Status_info,'Request Accepted')}}</span>
                  </li>
                  <li [ngClass]="getLeadCss(Lead_Status_info,'Request Accepted') ? 'active' : ''">
                    <span class="step-desc">Quote Tendered</span>
                    <span class="step-date">{{getLeadStatus(Lead_Status_info,'Request Accepted')}}</span>
                  </li>
                  <li [ngClass]="getLeadCss(Lead_Status_info,'C1A (Papers submitted)') ? 'active' : ''">
                    <span class="step-desc">Papers submitted</span>
                    <span class="step-date">{{getLeadStatus(Lead_Status_info,'C1A (Papers submitted)')}}</span>
                  </li>
                  <li [ngClass]="getLeadCss(Lead_Status_info,'C2 (Adv. Received)') ? 'active' : ''">
                    <span class="step-desc">Booking amount received</span>
                    <span class="step-date">{{getLeadStatus(Lead_Status_info,'C2 (Adv. Received)')}}</span>
                  </li>
                  <li *ngIf="(data?.lead_channel=='OSP_Configurator' || data?.lead_channel =='Fleet Verse Configurator')"
                    [ngClass]="(advReceived && (statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Order Created' || statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Ready for dispatch' || statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle dispatched' || statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle at dealership'))? 'active' : ''">
                    <span class="step-desc">order placed</span>
                    <span class="step-date">{{(advReceived && (statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Order
                      Created' || statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Ready for dispatch' ||
                      statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle dispatched' ||
                      statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle at dealership'))?
                      (statusOfTimeLine?.LAST_UPD_dt | date: 'dd-MM-yyyy'):''}}</span>
                  </li>
                  <li *ngIf="(data?.lead_channel=='OSP_Configurator' || data?.lead_channel =='Fleet Verse Configurator')"
                    [ngClass]="(advReceived && (statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Ready for dispatch' || statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle dispatched' || statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle at dealership'))? 'active' : ''">
                    <span class="step-desc">Ready for dispatch</span>
                    <span class="step-date">{{(advReceived && (statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Ready for
                      dispatch' || statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle dispatched' ||
                      statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle at dealership'))?
                      (statusOfTimeLine?.EXP_DATE_OF_BILLING_EDB_MAX_dt | date: 'dd-MM-yyyy'):''}}</span>
                  </li>
                  <li *ngIf="(data?.lead_channel =='OSP_Configurator' || data?.lead_channel =='Fleet Verse Configurator')"
                    [ngClass]="(advReceived && (statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle dispatched' ||  statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle at dealership'))? 'active' : ''">
                    <span class="step-desc">vehicle dispatched</span>
                    <span class="step-date">{{(advReceived && (statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle
                      dispatched'|| statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle at dealership'))?
                      (statusOfTimeLine?.EXP_TIME_OF_ARRIVAL_ETA_MAX_dt | date: 'dd-MM-yyyy'):''}}</span>
                  </li>
                  <li *ngIf="(data?.lead_channel =='OSP_Configurator' || data?.lead_channel =='Fleet Verse Configurator')"
                    [ngClass]="(advReceived && (statusOfTimeLine?.VEHICLE_BUILD_STATUS_s == 'Vehicle at dealership'))? 'active' : ''">
                    <span class="step-desc">vehicle available dealership</span>
                    <span class="step-date">{{(advReceived && ProgressBarData?.length > 0) ?
                      (statusOfTimeLine?.EXP_RETAIL_DELIVERY_DATE_ERDD_MAX_dt | date: 'dd-MM-yyyy'):''}}</span>
                  </li>
                  <li [ngClass]="getLeadCss(Lead_Status_info,'C3 (Vehicle Delivered)') ? 'active' : ''">
                    <span class="step-desc"> Delivered</span>
                    <span class="step-date">{{getLeadStatus(Lead_Status_info,'C3 (Vehicle Delivered)')}}</span>
                  </li>

                </ul>
              </div>
            </div>
            {{!isSecure ? 'Order Details' : ''}}
          </h1>
          <div class="card-list mb-3" *ngIf="!showBookingList && orderDetailsIndex == id">
            <div class="card status-card dealer-info" *ngIf="!isSecure">
              <div class="card-body">
                <div class="row g-4">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 border-end">
                    <label class="label-key">Dealer info</label>
                    <address class="label-value">
                      <p>{{ Dealer_info?.division_name }}</p>
                      <p>{{ Dealer_info?.address_line1 }} {{ Dealer_info?.address_line2 }} {{
                        Dealer_info?.area
                        }} {{
                        Dealer_info?.city }} {{ Dealer_info?.district }} {{ Dealer_info?.state_name }} {{
                        Dealer_info?.pincode }}</p>
                      <p class="mt-2">{{ Dealer_info?.mobile_number }}</p>
                    </address>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                    <div class="row">
                      <div class="col-6 mb-3">
                        <label class="label-key">Sales id</label>
                        <div class="label-value">{{ data?.opty_id ?
                          data?.opty_id
                          :
                          '-' }}</div>
                      </div>
                      <div class="col-6 mb-3">
                        <label class="label-key">Financier</label>
                        <div class="label-value">{{ data?.finance ?
                          data?.finance
                          :
                          '-' }}</div>
                      </div>
                      <div class="col-6">
                        <label class="label-key">Leasing interest</label>
                        <div class="label-value">{{data?.lease_interest ?
                          (data?.lease_interest | titlecase) : ''}}</div>
                      </div>
                      <div class="col-6">
                        <label class="label-key">AMC</label>
                        <div class="label-value">{{data?.amc ? (data?.amc
                          |
                          titlecase)
                          :
                          ''}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="card status-card dealer-info" *ngIf="isSecure">
              <div class="card-body">
                <div class="row gx-3 gy-2">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex">
                    <label class="label-key">Value added Services (VAS)</label>
                    <label class="label-key ms-auto text-capitalize" style="font-weight: 500;">
                      KYC Confirmed
                      <img [src]='environment1 + "assets/images/new-images/confirm.svg"' alt="confirm" loading="lazy">
                    </label>
                  </div>

                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-2 d-flex align-items-center border-top">
                  </div>

                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="row">
                      <div class="col-3">
                        <label class="label-key">Paid</label>
                        <div class="label-value">{{ bookingDataDeatail.vas_data[0].vas_payble_amount
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div class="card-list mb-3" *ngIf="!showBookingList && orderDetailsIndex == id">
            <h1 class="page-sub-title cv-text-dark mb-4 mt-4" style="font-size: 24px;"
              *ngIf="!isSecure && data?.vas_data?.length>0 && (data?.lead_channel == 'OSP_Configurator'|| data?.lead_channel =='Fleet Verse Configurator') ">
              Vas Information</h1>

            <div class="card status-card dealer-info"
              *ngIf="!isSecure && data?.vas_data?.length>0 && (data?.lead_channel == 'OSP_Configurator' || data?.lead_channel =='Fleet Verse Configurator' )">
              <div class="card-body">
                <div class="row g-4">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 border-end">
                    <div class="col-6 mb-3">

                      <label class="label-key">Vas Category</label>
                      <div class="label-value">{{ data?.vas_data[0]?.vas_category ?
                        data?.vas_data[0]?.vas_category :"-" }}</div>
                    </div>
                    <div class="col-6 mb-3">
                      <label class="label-key">Vas Status</label>
                      <div class="label-value">{{ data?.vas_data[0]?.vas_status ?
                        data?.vas_data[0]?.vas_status : "-" }}</div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                    <div class="row">
                      <div class="col-6">
                        <label class="label-key ml-10">AMC ID</label>
                        <div class="label-value ml-10">{{
                          data?.vas_data[0]?.vas_details[0]?.amc_order_id ?
                          data?.vas_data[0]?.vas_details[0]?.amc_order_id :"-" }}</div>
                      </div>
                      <div class="col-6 mb-3">
                        <label class="label-key ws-no">Vas Total Amount</label>
                        <div class="label-value ws-no">{{ data?.vas_data[0]?.vas_total_amount ?
                          data?.vas_data[0]?.vas_total_amount /100 :"-" }}</div>
                      </div>
                      <div class="col-6">
                        <label class="label-key ml-10">AMC ORDER NO.</label>
                        <div class="label-value ml-10 ws-no">
                          {{data?.vas_data[0]?.vas_details[0]?.amc_order_number ?
                          data?.vas_data[0]?.vas_details[0]?.amc_order_number : "-"}}</div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <!--no booking-->
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states" *ngIf="bookingData?.length == 0">
        <img [src]='environment1 + "assets/images/no_vehicle_booked.svg"' loading="lazy">
        <h3>
          No Vehicles Booked
        </h3>
        <div class="desc">
          You haven’t booked any vehicles at <br />the moment.
        </div>
      </div>
      <!--paging-->
      <div class="col-xs-12  paging-custom " *ngIf="bookingData?.length > 0">
        <pagination-controls class="col-xs-12" *ngIf="totalItemsBooking > itemsPerPage"
          (pageChange)="pageChangeBooking($event)" previousLabel=" " nextLabel=" " id='booking'
          [maxSize]="maximumSize"></pagination-controls>
      </div>
    </div>
  </div>

</div>







<!--retry pay modal-->

<ng-template #retryPay let-d="dismiss5">
  <div class="sidebar-drawer">
    <div class="dealer-review-form" *ngIf="showRetryPopup">
      <div class="drawer-header">
        <h5 class="drawer-title">Proceed to Payment</h5>
        <button type="button" (click)="close()" class="btn-close"></button>
      </div>
      <div class="drawer-body">

        <form [formGroup]="paymentTypeForm">

          <div class="prod-content">
            <div class="prod-img">
              <img
                src="{{currentLeadData?.vehicle_info?.image[0]?.image_url != '' ? currentLeadData?.vehicle_info?.image[0]?.image_url : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/image37.png'}}"
                class="img-fluid" alt="" loading="lazy">
            </div>
            <h6>{{currentLeadData?.dealer_info?.organization_name}}</h6>
            <p class="qty">
              QTY: {{currentLeadData?.quantity}}
            </p>
            <div class="mb-4">
              <label class="form-label mend">Booking amount per vehicle </label>
              <input maxlength="6" type="text" class="form-control h-48" (keypress)="onlyNumberKey($event)"
                autocomplete="new-password" numbersOnly formControlName="amount" placeholder="Booking Amount"
                (keyup)="getBookingAmount(currentLeadData)" (keydown)="notAllowSpace($event)" />

              <div class="error-message" *ngIf="hasRequiredError('amount')">&nbsp; <b>*Required</b></div>
              <div class="error-message" *ngIf="showAmountAlert">&nbsp; <b>*{{alertmsg}}</b></div>
              <div class="error-message" *ngIf="showRoomError">&nbsp; <b>*Booking amount should be less than ex showroom
                  price. </b></div>
              <div class="error-message" *ngIf="totalAmount > 500000">&nbsp; <b>*Maximum booking amount limit is set to
                  5 Lacs.</b></div>
            </div>
            <div class="mb-4" *ngIf="VasAmount ">
              <label class="form-label ">VAS Booking Amount :</label>
              <span style="color: #27292F;font-size: 16px;font-weight: 700;">
                &nbsp;&nbsp; {{VasAmount |currency:'INR':'symbol':'4.0-0'}}
              </span>
            </div>
          </div>
          <div *ngIf="showPaymentOption">
            <label class="form-label mb-3" style="color: #27292F;">Payment gateway</label>
            <div>
              <div class="form-check form-check-inline payment-selecttion-wrapper">
                <input class="form-check-input" type="radio" formControlName="paymentType" name="paymentType"
                  id="RAZORPAY" value="razorpay" checked>
                <label class="form-check-label" for="RAZORPAY">
                  <img alt="razorpay" [src]='environment1 + "assets/images/razorpay.svg"' class="img-fluid"
                    style="max-width: 110px;" loading="lazy" />
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" formControlName="paymentType" name="paymentType"
                  id="CCAVENUE" value="ccavenue">
                <label class="form-check-label" for="CCAVENUE"><img alt="ccAvenue"
                    [src]='environment1 + "assets/images/ccAvanue.svg"' style="max-width: 110px;" class="img-fluid"
                    loading="lazy" /></label>
              </div>
            </div>

          </div>

          <div class="cta-action d-grid">
            <div class="row w-100">
              <div class="col-6">
                <div style="color: 666C84; font-size: 14px;font-weight: 700;  line-height: 20px;">
                  Total Booking Amount
                </div>
                <div style="color: #27292F;font-size: 24px;font-weight: 700;">
                  {{totalAmount |currency:'INR':'symbol':'4.0-0'}}
                </div>
              </div>
              <div class="col-6">
                <button type="button" class="btn btn-primary btn-grad-primary btn-comment pt-3 pb-3 w-100"
                  (click)="submitPaymentMode(currentLeadData)">Continue</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<!--product review modal-->
<!-- <ng-template #productReview let-d="dismiss4">
  <app-product-review [data]="productReviewData"></app-product-review>
</ng-template> -->

<!--Dealer Review modal-->
<!-- <ng-template #dealerReview let-d="dismiss6">
  <app-dealer-review [reviewData]="reviewData" [dealerData]="dealerData"></app-dealer-review>
</ng-template> -->


<!-- //fni-wait-modal -->
<div class="modal modal-fetch-price fetchOn_price" id="fetchOn_price" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="fetchOn_priceLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <h1>Please wait while your request is being processed</h1>
        <p>This could take up to 10 minutes</p>
        <div class="text-center">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
